export default __webpack_public_path__ + "static/media/COAEcert.b99cffc6.png";